import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	isAuthenticate: false,
};

export const authSlice = createSlice({
	name: "authentication",
	initialState,
	reducers: {
		isAuthenticateTrue: (state) => {
			state.isAuthenticate = true;
		},
		isAuthenticateFalse: (state) => {
			state.isAuthenticate = false;
		},
	},
});

// Action creators are generated for each case reducer function
export const { isAuthenticateTrue, isAuthenticateFalse } = authSlice.actions;

export default authSlice.reducer;
